import styled from 'styled-components';

import { appColors } from '../../config/colors';
import { device } from '../../config/sizes';

export const ModalWrapper = styled.div<{ open: boolean }>`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: fixed;
  z-index: 4;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb(255, 255, 255);
  background-color: rgba(255, 255, 255, 0.9);
`;

export const ModalCard = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
`;

export const ModalContent = styled.div`
  overflow-y: auto;
  max-height: 85%;
  max-width: 1080px;
  margin: 5em 2em 2em;
  padding: 2em;
  color: ${appColors.modalFont};
  background-color: ${appColors.modalBackground};
  border-top: 2px solid ${appColors.border};
  border-right: 2px solid ${appColors.shadow};
  border-bottom: 2px solid ${appColors.shadow};
  border-left: 2px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};

  @media ${device.tablet} {
    margin: 2em;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    margin-top: 3rem;
  }
`;

export const ModalClose = styled.div`
  cursor: pointer;
  float: right;
`;

export const ModalButton = styled.button`
  cursor: pointer;
  display: block;
  font-weight: bold;
  font-size: 1em;
  text-decoration: none;
  text-align: center;
  margin: 1em auto 3em;
  padding: 1em;
  color: ${appColors.buttonFont};
  background-color: ${appColors.buttonBackground};
  border-top: 2px solid ${appColors.border};
  border-right: 2px solid ${appColors.shadow};
  border-bottom: 2px solid ${appColors.shadow};
  border-left: 2px solid ${appColors.border};
  box-shadow: 6px 7px 0px 0px ${appColors.shadow};
`;
